var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysNoFolder = function SvgSysNoFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sysNoFolder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 52a5 5 0 0 1-5-5l4-17a6.172 6.172 0 0 1 6.159-5l35.84.006v-2a3.157 3.157 0 0 0-2.995-3h-23a2 2 0 0 1-1.539-.717l-4.4-5.28H13a3.16 3.16 0 0 0-3 3v21.5l-2 8.493V17a5 5 0 0 1 1.506-3.488A5.016 5.016 0 0 1 13 12h10l5 6h23a5.01 5.01 0 0 1 3.488 1.51A4.985 4.985 0 0 1 56 23v2.074c2.4.342 4.521 1.936 4 4.928l-4.106 17.97.033-.142a5.062 5.062 0 0 1-1.1 2.293c.092-.113.18-.231.262-.351A4.964 4.964 0 0 1 51 52H13Zm.953-21.572-.006.033-3.942 16.742a3.01 3.01 0 0 0 2.995 2.8h38a3.193 3.193 0 0 0 2.929-2.437l.01-.043 4.101-17.91a1.933 1.933 0 0 0-.34-1.63 3.609 3.609 0 0 0-2.7-.98H18.16a4.166 4.166 0 0 0-4.207 3.427v-.002Zm41.905 17.697c0-.018.01-.035.013-.055a.515.515 0 0 0-.014.053v.002Zm.018-.074a3.608 3.608 0 0 0-.001-.002l.001.002Zm-.105-23.004a7.345 7.345 0 0 0-.002-.002l.002.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysNoFolder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export default SvgSysNoFolder;